import { fetchData } from "@request";

export type AdminCache = {
  // api_key: string;
  id: string;
  name: string;
};

export type AdminCachesResponse = AdminCache[];

export const getAdminCachesApi = async (userId: string) => {
  try {
    const response = await fetchData<AdminCachesResponse>({
      url: `api/v1/admin/caches/${userId}`,
    });

    return response;
  } catch (error) {
    console.error("getAdminCachesApi failed:", error);
    throw error;
  }
};

export type CreateCacheRequest = {
  name: string;
};

export const createAdminCacheApi = async (
  userId: string,
  data?: CreateCacheRequest
) => {
  try {
    const response = await fetchData<string>({
      url: `api/v1/admin/caches/${userId}`,
      method: "POST",
      data,
    });

    return response;
  } catch (error) {
    console.error("createAdminCacheApi failed:", error);
    throw error;
  }
};

export const changeAdminCacheApi = async (cacheId: string) => {
  try {
    const response = await fetchData<string>({
      url: `api/v1/admin/caches/change-api-key/${cacheId}`,
      method: "PUT",
    });

    return response;
  } catch (error) {
    console.error("changeAdminCacheApi failed:", error);
    throw error;
  }
};
